import React from "react";
import ReactDom from 'react-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import PropTypes from "prop-types";
import styles from 'views/component/Styles.js';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(styles);

export default function Confirm(props) {
    const { show, title, text, onConfirm, confirmText, cancelText, type } = props;
    const classes = useStyles();

    const base = document.getElementById('root')
    return ReactDom.createPortal(
        <SweetAlert
            type={type}
            style={{ display: "block", marginTop: "-100px" }}
            title={title}
            onConfirm={e => onConfirm(true)}
            onCancel={e => onConfirm(false)}
            confirmBtnCssClass={classes.button + " " + classes.danger}
            confirmBtnText={confirmText}
            cancelBtnCssClass={classes.button + " " + classes.warning}
            cancelBtnText={cancelText}
            showCancel={true}
            show={show}
        >
            {text}
        </SweetAlert>, base
    );
}
Confirm.defaultProps = {
    confirmText: "확인",
    cancelText: "취소",
    type: 'info'
}
Confirm.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
    text: PropTypes.string,
    onConfirm: PropTypes.func,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    type: PropTypes.oneOf(['default', 'secondary', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom'])
};
